module.exports = __webpack_public_path__ + "static/hero-f36a2e63684f4f2c7a73f77e5ef471c1.jpg";